var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.46,
    height: 14.34,
    viewBox: "0 0 121.46 14.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240812",
    "data-name": "Group 240812",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293011",
    "data-name": "Path 293011",
    d: "M11.74.141,8.28,9.3,4.74.141H0v14.1H3.92V6.4L6.6,14.24H9.881L12.54,6.46v7.78h3.921V.141Z",
    fill: "#033d9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293012",
    "data-name": "Path 293012",
    d: "M28.1.141,25.62,5.58,23.14.141H18.661l4.96,9.618V14.24H27.56V9.759L32.52.141Z",
    fill: "#033d9b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_240811",
    "data-name": "Group 240811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240813",
    "data-name": "Group 240813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293013",
    "data-name": "Path 293013",
    d: "M39.929,3.45A6.247,6.247,0,0,1,42.4.91,7.319,7.319,0,0,1,46.079,0a6.985,6.985,0,0,1,4.44,1.41,6.4,6.4,0,0,1,2.32,3.83h-4.22a2.823,2.823,0,0,0-1.05-1.22,2.857,2.857,0,0,0-1.55-.42,2.685,2.685,0,0,0-2.17.97,3.912,3.912,0,0,0-.81,2.59,3.941,3.941,0,0,0,.81,2.61,2.682,2.682,0,0,0,2.17.97,2.857,2.857,0,0,0,1.55-.42,2.818,2.818,0,0,0,1.05-1.22h4.22a6.4,6.4,0,0,1-2.32,3.831,6.985,6.985,0,0,1-4.44,1.409,7.319,7.319,0,0,1-3.68-.909,6.25,6.25,0,0,1-2.47-2.541,7.8,7.8,0,0,1-.87-3.73,7.756,7.756,0,0,1,.87-3.71",
    fill: "#3adbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293014",
    "data-name": "Path 293014",
    d: "M64.62,11.94h-5l-.76,2.3H54.74L59.88.14H64.4l5.12,14.1H65.38Zm-.98-3L62.12,4.379,60.62,8.94Z",
    fill: "#3adbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293015",
    "data-name": "Path 293015",
    d: "M78.939,14.24l-2.8-5.2h-.42v5.2H71.8V.14h6.18A6.4,6.4,0,0,1,80.86.73a4.136,4.136,0,0,1,1.779,1.62,4.5,4.5,0,0,1,.6,2.31,4.2,4.2,0,0,1-.791,2.53,4.268,4.268,0,0,1-2.31,1.55l3.181,5.5Zm-3.22-7.88h1.94a1.689,1.689,0,0,0,1.2-.38,1.447,1.447,0,0,0,.4-1.1,1.407,1.407,0,0,0-.41-1.07,1.659,1.659,0,0,0-1.19-.39h-1.94Z",
    fill: "#3adbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293016",
    "data-name": "Path 293016",
    d: "M89.939,3.28v2.3h4.5V8.56h-4.5V11.1h5.1v3.14H86.019V.14H95.04V3.28Z",
    fill: "#3adbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293017",
    "data-name": "Path 293017",
    d: "M101.9,3.28v2.3h4.5V8.56h-4.5V11.1H107v3.14H97.979V.14H107V3.28Z",
    fill: "#3adbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293018",
    "data-name": "Path 293018",
    d: "M117.079,14.24l-2.8-5.2h-.42v5.2h-3.92V.14h6.18A6.4,6.4,0,0,1,119,.73a4.136,4.136,0,0,1,1.779,1.62,4.5,4.5,0,0,1,.6,2.31,4.2,4.2,0,0,1-.791,2.53,4.268,4.268,0,0,1-2.31,1.55l3.181,5.5Zm-3.22-7.88h1.94a1.689,1.689,0,0,0,1.2-.38,1.447,1.447,0,0,0,.4-1.1,1.407,1.407,0,0,0-.41-1.07,1.659,1.659,0,0,0-1.19-.39h-1.94Z",
    fill: "#3adbb9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcLogo);
export default __webpack_public_path__ + "static/media/mc-logo.da57babd364b90c11b5cb8f5fc87f917.svg";
export { ForwardRef as ReactComponent };